<template>
  <v-container-np
    v-intersect="{
      handler: animateBox,
      options: {
        threshold: 0.5,
        root: null,
        rootMargin: '0px',
      },
    }"
    :class="{
      'h-100': fullHeightContainer === true,
      'animation-box-right': direction === 'right',
      'animation-box-left': direction === 'left',
      'animation-box-bottom': direction === 'bottom',
      'animation-box-top': direction === 'top',
      'animation-box-top-left': direction === 'top-left',
      'animation-box-top-right': direction === 'top-right',
      'animation-box-bottom-left': direction === 'bottom-left',
      'animation-box-bottom-right': direction === 'bottom-right',
    }"
  >
    <slot name="default" />
  </v-container-np>
</template>

<script setup lang="ts">
const props = defineProps<{
  fullHeightContainer?: boolean;
  direction:
    | "top"
    | "bottom"
    | "left"
    | "right"
    | "top-right"
    | "top-left"
    | "bottom-right"
    | "bottom-left";
}>();
function animateBox(
  isIntersecting: boolean,
  entries: IntersectionObserverEntry[],
  observer: IntersectionObserver
) {
  if (isIntersecting) {
    entries[0].target.classList.add("visible");
    observer.disconnect();
  }
}
</script>

<style>
.animation-box-left {
  opacity: 0;
  transform: translateX(-100px);
  transition: all 0.5s ease-in-out;
}

.animation-box-right {
  opacity: 0;
  transform: translateX(100px);
  transition: all 0.5s ease-in-out;
}

.animation-box-left.visible,
.animation-box-right.visible {
  opacity: 1;
  transform: translateY(0px);
}

.animation-box-top {
  opacity: 0;
  transform: translateY(-100px);
  transition: all 0.5s ease-in-out;
}

.animation-box-bottom {
  opacity: 0;
  transform: translateY(100px);
  transition: all 0.5s ease-in-out;
}

.animation-box-top.visible,
.animation-box-bottom.visible {
  opacity: 1;
  transform: translateY(0px);
}

.animation-box-top-left {
  opacity: 0;
  transform: translate(-100px, -100px);
  transition: all 0.5s ease-in-out;
}

.animation-box-top-right {
  opacity: 0;
  transform: translate(100px, -100px);
  transition: all 0.5s ease-in-out;
}

.animation-box-top-left.visible,
.animation-box-top-right.visible {
  opacity: 1;
  transform: translate(0px, 0px);
}

.animation-box-bottom-left {
  opacity: 0;
  transform: translate(-100px, 100px);
  transition: all 0.5s ease-in-out;
}

.animation-box-bottom-right {
  opacity: 0;
  transform: translate(100px, 100px);
  transition: all 0.5s ease-in-out;
}

.animation-box-bottom-left.visible,
.animation-box-bottom-right.visible {
  opacity: 1;
  transform: translate(0px, 0px);
}
</style>
